import Helper from "./Helper";
import * as S from './../Vars/shares';
import SharesShared from "./SharesShared";

/**
 * Shares Data Handler
 * ------------------------
 * - handles the Shares File Data
 * - builds Shares Tile HTML and appends it to container
 */
class SharesData {
  constructor() {}

  sharesParser(data) {
    data.forEach((rowInput, index) => {
      const row = rowInput.filter(e => e);
      if (index > 0) {
        let firm;
        const dropDownVals = [];
        const filterVals = [];
        row.forEach((col, i) => {
          if (i == 0) {
            firm = col;
          } else if (i <= S.dropDowns.length) {
            // these cols correspond to dropdwns (make sure order is correct in backend settings)
            dropDownVals.push(col);
          } else {
            if (parseFloat(col)) {
              col = parseFloat(col);
            }
            filterVals.push(col);
          }
        });
        if (firm) {
          this.setExtremes(filterVals);
          this.buildTile(firm, dropDownVals, filterVals);
        }
      }
    });

    this.buildBarGrid(15);
  }

  buildBarGrid(gridSteps) {
    const grid = document.createElement('div');
    Helper.addClass(grid, 'bar-view-grid');
    let html = '';
    for (let line = 0; line < gridSteps; line++) {
      html += `<div class="bar-view-grid__line"></div>`;
    }
    grid.innerHTML = html;
    S.sharesContainer.append(grid);

    const lines = [...document.querySelectorAll('.bar-view-grid__line')];

    S.filtersArr.forEach(filter => {
      const min = (filter.min < 0) ? filter.min : 0;
      const steps = SharesShared.getRange(filter.max, min, gridSteps)
      const stepsPretty = [];
      steps.forEach(step => {
        step = Math.round((step + Number.EPSILON) * 100) / 100; // round to two digits after comma
        stepsPretty.push(step);
      });
      lines.forEach((line, i) => {
        line.setAttribute(`data-filter-${filter.id}-label`, SharesShared.formatNumString(stepsPretty[i], S.decimalPoint, S.thousandsSep));
      });

      const bars = [...document.querySelectorAll('.share-info__bar[data-filter-id="' + filter.id + '"]')];
      let isNegative = false;
      if (min < 0) {
        isNegative = true;
      }
      const rangeTotal = (isNegative) ? filter.max + (min * -1) : filter.max;

      bars.forEach((bar, i) => {
        let val = bar.getAttribute('data-val');
        let width = 0;
        let mL = 0;
        if (val > 0) {
          width = val / rangeTotal * 100;
          if (isNegative) {
            mL = (min * -1) / rangeTotal * 100;
          }
        } else {
          Helper.addClass(bar, 'is-negative');
          width = (val * -1) / rangeTotal * 100;
          mL = ((min * -1) - (val * -1)) / rangeTotal * 100;
        }
        bar.style.marginLeft = mL + '%';
        bar.style.width = width + '%';
      });
    });
  }

  setExtremes(filterVals) {
    S.filtersArr.forEach((filter, index) => {
      const filterValue = filterVals[index];
      filter.max = (filter.max == undefined || filter.max < filterValue) ? filterValue : filter.max;
      filter.min = (filter.min == undefined || filter.min > filterValue) ? filterValue : filter.min;
    });
  }

  buildTile(firm, dropDownVals, filterVals) {
    // let render = false;
    let tile = document.createElement("div");
    Helper.addClass(tile, "share-info");
    dropDownVals.forEach((ddv, i) => {
      const dropVal = "drop-" + i + "-" + ddv;
      tile.setAttribute(`data-drop-${i}`, ddv);
    });
    tile.setAttribute("data-filter-alphabet", firm.toLowerCase().replace(/ /g, ''));
    let html = `<h2 class="share-info__title">${firm}</h2>`;
    filterVals.forEach((val, i) => {
      const currFilter = S.filtersArr[i];
      const active = i == 0 ? "active" : "";
      const formatedVal = SharesShared.formatNumString(val, S.decimalPoint, S.thousandsSep);
      if (currFilter) {
        tile.setAttribute(`data-filter-${currFilter.id}`, val);
        html += `<div data-is-filter="filter-${currFilter.id}" class="share-info__filter-info ${active}">`;
        html += `<div class="share-info__number">${formatedVal}${currFilter.afterNumString}</div>`;
        html += `<div class="share-info__desc">${currFilter.tileText}</div>`;
        html += `<div class="share-info__bar-wrap"><div class="share-info__bar" data-label="${formatedVal}" data-val="${val}" data-filter-id="${currFilter.id}"></div></div>`;
        html += `</div>`;
        // render = true;
      }
    });
    const chartURLstring = firm.replace(/ /g, '-').replace(/\./g, '');
    const chartName = firm.split(" ").join("");
    html += `<div class="share-info__btns">
              <a href="${S.portfolioLink}?chart=${chartName}" class="ns-link ns-link--chart">
                <span>${S.toComparisonButtonText}</span>
              </a>
              <a href="${S.sharesURLExternal}/${chartURLstring}" target="_blank" class="ns-link ns-link--info">i</a>
            </div>`;
    tile.innerHTML = html;
    // if (render) {
      S.sharesContainer.append(tile);
    // }
    S.tiles = [...document.querySelectorAll(".share-info")];
    SharesShared.sort("alphabet", 0);
  }
}

export default SharesData;
